module.exports = __webpack_public_path__ + "icon-arrow-right-dark.svg?6513d4edb4b7abdec2fd5d7c2001cf3c";